import { render, staticRenderFns } from "./usage-record.vue?vue&type=template&id=4054d72e&"
import script from "./usage-record.vue?vue&type=script&lang=js&"
export * from "./usage-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4054d72e')) {
      api.createRecord('4054d72e', component.options)
    } else {
      api.reload('4054d72e', component.options)
    }
    module.hot.accept("./usage-record.vue?vue&type=template&id=4054d72e&", function () {
      api.rerender('4054d72e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/usage-record/usage-record.vue"
export default component.exports